<template>
  <div>
    <el-card class="main" shadow="never">
      <el-alert
      title="操作步骤：1.搜索框中检索出要导入的商品  2.从左侧（搜索源数据）中勾选要导出的数据，并点击箭头>（箭头<为回退操作） 3.右侧框中的数据即你要导入本店的数据，确认数据无误直接点击立即导入"
      type="info">
  </el-alert>
        <div class="content">
        <div class="search">
          <el-input placeholder="选择搜索类型" v-model="keyword" size="mini" class="input-with-select">
            <!-- <el-select class="first_class" v-model="cateValue" slot="prepend" placeholder="请选择">
              <el-option
              v-for="item in categoryl"
              :key="item.id"
              :label="item.cate_name"
              :value="item.id">
            </el-option>
            </el-select> -->
            <el-select class="first_class2" v-model="searchType" slot="prepend" placeholder="请选择">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="searchP"></el-button>
          </el-input>
        </div>  
        <el-transfer v-model="selectValue" :titles="['全选（搜索源数据）','全选（导入店铺数据）']" :data="data"  :render-content="renderFunc">
           <el-button class="transfer-footer" type="primary" slot="right-footer" @click="insertProduct" :disabled="insertStatus" size="small">立即导入</el-button>
           <span class="transfer-footer"  slot="left-footer" size="small"></span>
        </el-transfer>
        </div>
    </el-card>
  </div>
</template>
<script>
export default {


  data() {
      return {
        keyword: '',
        data: [],
        selectValue: [],
        options: [{
          value: '1',
          label: '标题'
        }, {
          value: '2',
          label: '品牌'
        }, {
          value: '3',
          label: '货号'
        }],
        categoryl: [],
        cateValue: '',
        searchType: '',
        insertStatus: false,
      };
    // return {
    //   token: this.$cookies.get("shop_token")
    // };
  },
  created() {
    this.$store.state.shop_top = 1;
    this.$store.state.shop_left = "添加商品";
    this.axios
      .get(this.$store.state.serve + "shop/get_cate_name", {
        params: {
          token: this.$cookies.get("shop_token"),
          username: this.$cookies.get("shop_username"),
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.categoryl = res.data.data;
        }
      });
  },
  methods: {
    renderFunc(h,option){
      return <span title={option.label}>{option.label}</span>
    },
    searchP () { //搜索源数据
       var keyword = this.keyword.trim();
       if(keyword == ''){
          this.$alerts.error("请输入要搜索的关键字", this.$message);
          return false;
       }
       const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
       this.axios
        .get(this.$store.state.serve + "shop/getMartProduct", {
          params: {
            token: this.$cookies.get("shop_token"),
            username: this.$cookies.get("shop_username"),
            title: keyword,
            type: this.searchType
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            var data = res.data.data;
            var newArr = [];
            for(var i=0;i<data.length;i++){
               newArr.push({
                key: data[i]['id'],
                label: `标题【${data[i]['title']}】-货号【${data[i]['item_no']}】-商标【${data[i]['brand']}】`
               })
            }
            this.data = newArr;
          }else{
            this.data = [];
            this.$alerts.error("未找到你要搜索的数据！", this.$message);
          }
          loading.close();
        });
    },
    insertProduct (){ //导入数据
       var that = this;
       if(this.selectValue.length == 0){
         this.$alerts.error("要导入的数据不能为空！", this.$message);
         return false;
       }
      
      this.insertStatus = true;
      this.axios
        .get(this.$store.state.serve + "shop/insertMartProduct", {
          params: {
            token: this.$cookies.get("shop_token"),
            username: this.$cookies.get("shop_username"),
            ids: this.selectValue
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$alerts.success("导入数据成功", this.$message);
          }else{
            this.$alerts.error(res.data.msg, this.$message);
          }
          setTimeout(() => {
            that.insertStatus = false;
            //that.selectValue = [];
            //that.data = [];
          }, 1000);
        });
          
    }
  }
};
</script>
<style lang='scss'>
.main{
  min-height: 600px;
  .el-alert--info.is-light{
      margin-bottom: 20px;
  }
  .first_class2{
    width: 85px;
  }
  .first_class{
    width: 180px;
    margin-right: 25px;
    border-right: 1px solid #dcdfe6;
  }
  .content{
    margin: 0 auto;
    .search{
       width: 600px;
       margin:0  auto;
       display: flex;
    }
    .el-transfer{
      margin-top: 20px;
      .el-transfer-panel{
        width:335px;
        .el-transfer-panel__body{
          height: 336px;
          .el-transfer-panel__list{
            height: 336px;
          }
        }
      }
      .el-transfer-panel__footer{
        text-align: center;
      }
    }
  }
}
</style>